



















import AlertEnableToggle from "@/components/AlertEnableToggle.vue";
import AlertRemove from "@/components/AlertRemove.vue";
import AlertForm from "@/components/AlertForm.vue";
import AlertInfo from "@/components/AlertInfo.vue";
import { Alert } from "@/types/alert";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {
    AlertEnableToggle,
    AlertRemove,
    AlertForm,
    AlertInfo,
  },
})
export default class AlertItem extends Vue {
  @Prop({ required: true })
  alert!: Alert;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  showEditAlert = false;

  toggleEditAlert() {
    this.showEditAlert = !this.showEditAlert;
    this.$ga.toggle("Toggle edit alert");
  }
}
